<template>
    <div class="main">
        <p class="title">区县排行</p>
        <div class="rank-contain">
            <areaCountryEarChat :rankList="countyCompareData" />
        </div>
    </div>
</template>

<script>
    import areaCountryEarChat from '../components/areaCountryEarchat.vue';
    export default {
        components: {
            areaCountryEarChat
        },
        props: ['countyCompareData'],
        data () {
            return {
                rankList: [
                    { 'id': 1, 'city': '巍山县', 'mark': '9.9', 'changeRank': 2 },
                    { 'id': 2, 'city': '云龙县', 'mark': '8.9', 'changeRank': 2 },
                    { 'id': 3, 'city': '洱源县', 'mark': '7.2', 'changeRank': 2 },
                    { 'id': 4, 'city': '祥云县', 'mark': '6.5', 'changeRank': 2 },
                    { 'id': 5, 'city': '宾川县', 'mark': '5.5', 'changeRank': 2 },
                    { 'id': 6, 'city': '宾川县', 'mark': '3.9', 'changeRank': 2 }
                ]
            }
        }
    }
</script>

<style lang="less" scoped>
.main {
    width:100%;
    background-color: #fff;
    .title{
        // margin-bottom: 8px;
        // padding-top:23px;
        margin-left:9px;
        font-size:10px;
        line-height: 28px;
        color:#999;
    }
    .rank-contai {
        padding:0 16px;
        height: 250px;
    }
}
</style>
